module.exports = __webpack_public_path__ + "img/Sasha Pitkevich.50b8f4a9.jpg";